import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddProductModelPopupComponent } from '../add-product-model-popup/add-product-model-popup.component';


@Component({
  selector: 'app-my-products',
  templateUrl: './my-products.component.html',
  styleUrls: ['./my-products.component.css']
})
export class MyProductsComponent implements OnInit {
 fields: string[] = [
    'Product Category', 'Product Sub Category', 'Product Name', 'Product Meta Data',
    'Product Description', 'Brand Name', 'Product Code', 'MRP',
    'Business Price', 'You Save', 'Buy More', 'Save More',
    'GST', 'Style/Model Name', 'in Stock'
  ];

  imageSlots = Array(6).fill(null);
  videoSlots = Array(4).fill(null);

  reviews = [
    { name: 'Angela Babu', comment: 'Nice Product' },
    { name: 'Sonal', comment: 'Good Product, Value for money' }
  ];
  constructor(    private modalService: NgbModal,
  ) { }

  ngOnInit(): void {
  }
  addProduct(){
    const modelRef = this.modalService.open(AddProductModelPopupComponent, { size: 'lg', });

  }


}
